import React from 'react';
import WorkflowIcon from './WorkflowIcon';
const stages=[['queued','Queued','calendar'],['running','Research','research'],['applying','Save draft','documents'],['complete','Ready for review','review']];
export default function ResearchFlow({status}) {
 const current=stages.findIndex(([key])=>key===status);
 return <ol className="research-flow" aria-label="Research stages">{stages.map(([key,label,icon],index)=><li key={key} data-state={current===index?'current':current>index?'passed':'pending'} aria-current={current===index?'step':undefined}><WorkflowIcon name={icon} size={18}/><span>{label}</span></li>)}</ol>;
}
